import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const metaMap = {
  "/": {
    title: "Book Best Party Venues, Bars & Cafes in Delhi-NCR",
    description: "Book the best party venues, bars, cafés, and top lounges near me in Delhi-NCR. Explore options, get offers & deals with PartyWitty’s booking platform.",
    keyword: "party venues near me, book party places, party spots Delhi NCR, bars near me, cafés near me, lounges in Delhi, birthday venues, BYOB places, rooftop party venues, nightclubs near me, book restaurant for party, party places in Noida, clubs in Gurgaon, lounges in South Delhi, PartyWitty booking, best party venues in Delhi NCR"
  },
  "/feed": {
    title: "Party Packages | Corporate Party Places, Cocktail Party Bar, Pubs",
    description: "Book party packages at top venues for birthdays, cocktails, and corporate events in Delhi NCR.",
    keyword: "party venues near me, book party places, party spots Delhi NCR, bars near me, cafés near me, lounges in Delhi, birthday venues, BYOB places, rooftop party venues, nightclubs near me, book restaurant for party, party places in Noida, clubs in Gurgaon, lounges in South Delhi, PartyWitty booking, best party venues in Delhi NCR"
  },
  "/party-packages": {
    title: "Book Top Venues & Party Packages Deals in Delhi NCR",
    description: "Explore the best party packages, group party venues, and night clubs in Delhi NCR. Book your perfect party spot with Party Witty – your trusted party booking app.",
    keyword: "party packages, birthday party packages, bachelor party deals, corporate party packages, party deals in Noida, party deals in Delhi NCR, book party packages, affordable party packages, customized party packages, venue booking, group party packages"
  },
  "/artist-page": {
    title: "PartyWitty - Our Artists",
    description: "Explore PartyWitty's top-rated artists and performers.",
  },
  "/club-about-us": {
    title: "PartyWitty - Club About Us",
    description: "Learn more about PartyWitty and our club offerings.",
  },
  "/BookATableViewAll": {
    title: "PartyWitty - Book a Table",
    description: "Reserve tables instantly at clubs, bars, and restaurants with exclusive deals.",
  },
  "/events": {
    title: "Book Events & Celebrations in Delhi NCR – Top Venues & Deals",
    description: "Looking for event booking in Delhi NCR? Discover top venues, curated packages, and best deals for birthdays, weddings, and corporate events.",
    keyword: "event booking Delhi NCR, celebration venues,  group event booking, event venues near me, birthday celebration places, corporate event packages, book events online, top party venues Delhi NCR, PartyWitty event deals"
  },
  "/venues": {
    title: "Instant Table Booking – Deals on Clubs & Restaurants Nearby",
    description: "Reserve tables online at top party venues in Delhi-NCR. Get amazing offers on clubs, cafes, and restaurants with PartyWitty’s easy booking.",
    keyword: "table booking Delhi NCR, restaurant table reservation, club table booking, book tables online, party table booking, dining reservation Delhi, table booking for parties, PartyWitty table deals"
  },
  "/my-plan": {
    title: "Book Party Packages with Food & Drinks – Best Deals",
    description: "Submit your package leads and get exclusive offers on top venues.",
    keyword: "party packages with food and drinks,  all-inclusive party packages, group party food deals, buffet party packages,  party offers with food, PartyWitty food & drink deals"
  },
  "/package-lead-form": {
    title: "Book Party Packages with Food & Drinks – Best Deals",
    description: "Book party packages with food & drinks at nearby venues. Compare deals, view menus, and reserve your celebration instantly with PartyWitty.",
    keyword: "party packages with food and drinks,  all-inclusive party packages, group party food deals, buffet party packages,  party offers with food, PartyWitty food & drink deals"
  },
  "/table-book-form": {
    title: "Instant Party Table Booking with Best Deals | PartyWitty",
    description: "Submit your package leads and get exclusive offers on top venuesReserve your party table instantly with PartyWitty. Enjoy exclusive deals on food, drinks & venue bookings for birthdays, kitty parties, and more.",
    keyword: "instant party table booking, party table reservation, quick table booking, book party table online, table deals for parties, club table booking, restaurant table booking Delhi NCR,  best table deals, PartyWitty table booking"
  },
  "/corporate-recreation-program":{
    title: "Corporate Recreation Program | Employee Engagement & Team Building Activities",
    description: "Boost employee engagement with corporate events, team building activities, and themed parties. Party Witty helps plan impactful company events tailored for team bonding and workplace fun.",
  }
};


const MetaHead = () => {
  const location = useLocation();
  const meta = metaMap[location.pathname] || {
    title: "PartyWitty",
    description: "Discover clubs, events, and party packages in Delhi NCR.",
  };

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta name="keywords" content={meta.keyword} />
    </Helmet>
  );
};

export default MetaHead;
